import { ProductTypeFormat } from './types'

export default abstract class AbstractProductType {

  abstract readonly name: string
  abstract readonly title: string

  readonly curbside: boolean = false
  readonly oversized: boolean = false
  readonly valet: boolean = false
  abstract readonly format: ProductTypeFormat

}
